import 'css-chunksrc/client/scenes/documentCreation/form/templates/styles.scss';export default {
  "templates": "_templates_49m1e_1",
  "title": "_title_49m1e_8",
  "list": "_list_49m1e_14",
  "templateBox": "_templateBox_49m1e_22",
  "loader": "_loader_49m1e_28",
  "loaderIcon": "_loaderIcon_49m1e_34"
};